import { ActionsObservable, combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, pluck } from 'rxjs/operators'

import { fetchPlaybooksById } from 'api/conversation/playbooks'
import { fromRequest } from 'utils/api'

import * as actions from './actions'

const fetchPlaybooksByIds = (action$: ActionsObservable<any>) =>
  action$.pipe(
    ofType(actions.fetchPlaybooksByIds.toString()),
    pluck('payload'),
    mergeMap((playbookIds) =>
      fromRequest(fetchPlaybooksById(playbookIds)).pipe(
        map((playbooksById) =>
          actions.receivePlaybooks(playbooksById, { merge: true })
        ),
        catchError((error) => {
          console.error(error)
          return of(actions.fetchPlaybooksByIdsFailed({ playbookIds, error }))
        })
      )
    )
  )

export default combineEpics(fetchPlaybooksByIds)
